import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export function usePropertyTypeSchema() {
   const { t } = useI18n();

   const PROPERTY_TYPE_OPTION_SCHEMA = yup.object().shape({
      name: yup.string().required().label(t('generic.option')),
      id: yup.number().optional(),
      is_used: yup.boolean().optional(),
   });

   const PROPERTY_TYPE_SCHEMA = yup.object().shape({
      name: yup.string().required().label(t('generic.name')),
      company_properties: yup.array().of(PROPERTY_TYPE_OPTION_SCHEMA).min(1).required(),
   });

   return { PROPERTY_TYPE_SCHEMA, PROPERTY_TYPE_OPTION_SCHEMA };
}

export function getDefaultPropertyTypeData() {
   return {
      company_properties: [{ name: '' }],
   };
}

export function mapPropertyTypeFormErrors(errors: { [key: string]: string }) {
   const mapped = { ...errors };

   for (const [path, message] of Object.entries(errors)) {
      const match = path.match(/^company_properties\[(\d+)\]\.name$/);
      if (match) {
         mapped[`property-${match[1]}-name`] = message;
      }
   }

   return mapped;
}
